var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _vm.dialog
        ? _c("ClientEditModal", {
            attrs: {
              dialog: _vm.dialog,
              companyId: _vm.companyId,
              currentUser: _vm.currentUser,
              activeTab: _vm.activeTab,
              isCareplanExist: _vm.isCareplanExist,
              initialData: {},
              isEdit: false,
              currentEditTab: _vm.currentEditTab,
            },
            on: { closeDialog: _vm.hanldeCancel, close: _vm.handleClose },
          })
        : _vm._e(),
      _c("UIButton", {
        staticClass: "ml-4 font-outfit",
        attrs: { buttonText: _vm.text, variant: "black", size: "lg" },
        on: { click: _vm.toggle },
        scopedSlots: _vm._u([
          {
            key: "icon",
            fn: function () {
              return [_c("PlusIcon", { staticClass: "w-4 h-4" })]
            },
            proxy: true,
          },
          {
            key: "hover-icon",
            fn: function () {
              return [_c("HoveredIcon", { staticClass: "w-6 h-6" })]
            },
            proxy: true,
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }